export const QUICK_SELECT_PASTEL_COLORS: string[] = [
  '#FFB3B3',
  '#FFD9B3',
  '#FFF5B3',
  '#B3FFB3',
  '#B3D9FF',
  '#D9B3FF',
  '#FFB3E6',
  '#B3FFF0',
  '#E6CCB3',
  '#D9D9D9',
];

export const PastelColors = [
  '#EAC7C7',
  '#C9B29B',
  '#D1E8E2',
  '#CBC3E3',
  '#F5C6EC',
  '#F4C2C2',
  '#CBB7A2',
  '#B5DAD7',
  '#E5D9F2',
  '#F3E8F0',
  '#EFD6D2',
  '#E4CDA7',
  '#B0E0E6',
  '#D5C6E0',
  '#FEC5BB',
  '#F6E2B3',
  '#ADD8E6',
  '#D7BDE2',
  '#F8EDEB',
  '#AEC6CF',
  '#E0BBE4',
  '#BFA6A0',
  '#C3DFF0',
  '#D8BFD8',
  '#D7CCC8',
  '#DBE9F4',
  '#EEC9B7',
  '#BCCCDC',
  '#F7D1BA',
  '#E2EAF4',
  '#EFD8C5',
  '#CADCF9',
  '#F9DCC4',
  '#E6E6FA',
  '#DACBBE',
  '#F6DFEB',
  '#F8C8DC',
  '#F5E1E7',
  '#FFE5EC',
  '#FFD1DC',
];

export const DEFAULT_PHASE_COLOR = '#000000';
